export default __webpack_public_path__ + "static/media/slide9.a42f6410.jpg";